import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-send-flow-alert',
  templateUrl: './delete-flow-alert.component.html',
  styleUrls: ['./delete-flow-alert.component.scss'],
})
export class DeleteFlowAlertComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
